import React from "react";
import WishlistButton from "./WishlistButton";
function Mobiles(){
    return <div className="Mobiles">

           <div className ="card">
        <div className="catalog-section-title"><i class="fab fa-apple fa-5x"></i> <h1>Apple Mobiles</h1></div>
        <div className="row">

            <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body">
<img src={process.env.PUBLIC_URL + "/images/mobileimages/Apple iphone 7.jpeg"}alt=""  />
       </div>
       <div className="card-header">
<h6>Apple iphone7(Black 32GB)</h6>
<p>Black 32 GB ROM11.94 cm (4.7 inch) Retina HD Display12MP Rear Camera | 7MP Front Camera)</p>
<h4> ₹28,400 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>   
        </div>


           <div className="pricing-column col-lg-3 col-md-6">
       <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/mobileimages/Apple iphone 7plus.jpeg"}alt=""  /></div>
       <div className="card-header"><h6>Apple iphone7plus(Black 32GB</h6><p>Black 32 GB ROM 13.97 cm (5.5 inch) Retina HD Display12MP + 12MP | 7MP Front Camera</p><h4> ₹34,999 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div> 
        </div> 

          <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/mobileimages/Apple iphone SE.jpeg"} alt="" /></div>
       <div className="card-header"><h6>Apple iphone SE(Black 128GB)</h6><p>Black 128 GB ROM |11.94 cm (4.7 inch) Retina HD Display | 12MP Rear Camera | 7MP Front Camera</p><h4> ₹47,800 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>

          <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/mobileimages/Apple iphone XS.jpeg"}alt=""  /></div>
       <div className="card-header"><h6>Apple iphone XS(Space Grey, 64 GB)</h6><p>space Grey 64 GB ROM |14.73 cm (5.8 inch) Super Retina HD Display |12MP + 12MP | 7MP Front Camera</p><h4> ₹59,999 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>
       </div>
       </div>

<div class ="card">
        <br/>
        <div className="catalog-section-title"><h1 className="oneplus">OnePlus Mobiles</h1></div>
        <div class="row">

          <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/mobileimages/OnePlus 6T.jpeg"}alt=""  /></div>
       <div className="card-header"><h6>OnePlus 6T (Mirror Black, 128 GB)</h6><p>OnePlus 6 |GB RAM | 128 GB ROM|16.28 cm (6.41 inch) Display|16 MP + 20 MP | 16MP Front Camera</p><h4> ₹30,999 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>

        <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/mobileimages/OnePlus 7.jpeg"}alt=""  /></div>
       <div className="card-header"><h6>OnePlus 7 (Mirror Grey, 256 GB)</h6><p>OnePlus 7 |8 GB RAM | 256 GB ROM |16.28 cm (6.41 inch) Display |48 MP + 5 MP | 16MP Front Camera</p><h4> ₹35,989 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>
    
        <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/mobileimages/OnePlus 7T.jpeg"}alt=""  /></div>
       <div className="card-header"><h6>OnePlus 7T  (Haze Blue, 256 GB)</h6><p>OnePlus 7T |8 GB RAM | 256 GB ROM |16.94 cm (6.67 inch) Quad HD+ Display|48MP +8MP+16MP Camera</p><h4> ₹47,999 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>

        <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/mobileimages/OnePlus 8.jpeg"} alt="" /></div>
       <div className="card-header"><h6>OnePlus 8 (Onyx Black, 128 GB)</h6><p>OnePlus 8 GB RAM | 256 GB ROM |16.28 cm (6.41 inch) Display |48 MP + 5 MP | 16MP Front Camera</p><h4> ₹49,999 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>
        </div>
        </div>

<div class ="card">
        <br/>
        <div className="catalog-section-title"><h1 className="Oppo">Oppo Mobiles</h1></div>
        <div class="row">

       <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/mobileimages/Oppo A1k.jpeg"}alt=""  /></div>
       <div className="card-header"><h6>Oppo A1K (Red, 32 GB)</h6><p>Oppo A1K 2 GB RAM | 32 GB ROM | Expandable Upto 256 GB|15.49 cm (6.1 inch) Display| 5MP Front Camera</p><h4> ₹7,990</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton /> 
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>

        <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/mobileimages/Oppo A5 2020.jpeg"}alt=""  /></div>
       <div className="card-header"><h6>Oppo A5 2020 (White, 64 GB)</h6><p>Oppo A5 20204 GB RAM | 64 GB ROM|16.51 cm (6.5 inch) Display|12MP + 8MP + 2MP | 8MP Front Camera</p><h4> ₹13,990</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton /> 
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>

        <div className="pricing-column col-lg-3 col-md-6">
       <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/mobileimages/Oppo A12.jpeg"} alt="" /></div>
       <div className="card-header"><h6>Oppo A12 (Black, 32 GB)</h6><p>3 GB RAM | 32 GB ROM | Expandable Upto 256 GB|15.8 cm (6.22 inch) HD+ Display|13MP | 5MP Front Camera</p><h4> ₹9,990</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton /> 
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>


        <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body">
<img src={process.env.PUBLIC_URL + "/images/mobileimages/Oppo A31.jpeg"}alt=""  />
       </div>
       <div className="card-header">
<h6>Oppo A31 (Mystery Black, 64 GB)</h6>
<p>4 GB RAM | 64 GB ROM | Expandable Upto 256 GB|16.51 cm (6.5 inch) HD+ Display|12MP| 8MP Front Camera</p>
<h4> ₹12,490</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton /> 
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>


        <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body">
<img src={process.env.PUBLIC_URL + "/images/mobileimages/Oppo A52.jpeg"}alt=""  />
       </div>
       <div className="card-header">
<h6>Oppo A52 (Twilight Black, 128 GB) </h6>
<p>6 GB RAM | 128 GB ROM |Expandable Upto 256 GB|16.51 cm (6.5 inch) Full HD+ Display|16MP Front Camera</p>
<h4> ₹16,990</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton /> 
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>


        
        <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body">
<img src={process.env.PUBLIC_URL + "/images/mobileimages/Oppo F11 pro.jpeg"}alt=""  />
       </div>
       <div className="card-header">
<h6>Oppo F11 Pro (Thunder Black, 128 GB)</h6>
<p>6 GB RAM | 128 GB ROM | Expandable Upto 256 GB|16.51 cm (6.5 inch) Full HD+ Display| 48MP Front Camera</p>
<h4> ₹17,990</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton /> 
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>



        <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body">
<img src={process.env.PUBLIC_URL + "/images/mobileimages/Oppo Reno 10x Zoom.jpeg"}alt=""  />
       </div>
       <div className="card-header">
<h6>Oppo Reno 10xZoom(Ocean, 256 GB)</h6>
<p>8 GB RAM | 256 GB ROM | Expandable Upto 256 GB|16.76 cm (6.6 inch) Display|48MP  | 16MP Front Camera</p>
<h4> ₹17,990</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton /> 
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>


    </div>
    </div>  


    <div class ="card">
        <br/>
        <div className="catalog-section-title"><h1 className="Redmi">Redmi Mobiles</h1></div>
        <div class="row">


        <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body">
<img src={process.env.PUBLIC_URL + "/images/mobileimages/Redmi 6pro.jpeg"}alt=""  />
       </div>
       <div className="card-header">
<h6>Redmi Note 6 Pro (Black, 64 GB)</h6>
<p>6 GB RAM | 64 GB ROM | Expandable Upto 256 GB|15.9 cm (6.26 inch) Full HD+ Display|20MP Front Camera</p>
<h4> ₹11,999</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton /> 
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>


        
        <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body">
<img src={process.env.PUBLIC_URL + "/images/mobileimages/Redmi K20.jpeg"} alt="" />
       </div>
       <div className="card-header">
<h6>Redmi K20 (Glacier Blue, 128 GB)</h6>
<p>6 GB RAM | 128 GB ROM|16.23 cm (6.39 inch) Full HD+ Display|48MP + 13MP + 8MP | 20MP Front Camera</p>
<h4> ₹24,999</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton /> 
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>



        <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body">
<img src={process.env.PUBLIC_URL + "/images/mobileimages/Redmi K20pro.jpeg"} alt="" />
       </div>
       <div className="card-header">
<h6>Redmi K20 Pro (Flame Red, 128 GB)</h6>
<p>6 GB RAM | 128 GB ROM|16.23 cm (6.39 inch) Full HD+ Display|48MP + 13MP + 8MP | 20MP Front Camera</p>
<h4> ₹24,999</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton /> 
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>


        
        <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body">
<img src={process.env.PUBLIC_URL + "/images/mobileimages/Redmi Note7pro.jpeg"}alt=""  />
       </div>
       <div className="card-header">
<h6>Redmi Note 7 Pro (Black, 128 GB)</h6>
<p>6 GB RAM | 128 GB ROM | Expandable 256GB|16.0 cm (6.3 inch) Full HD+ Display|48MP| 13MP Front Camera</p>
<h4> ₹13,999</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton /> 
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>



        <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body">
<img src={process.env.PUBLIC_URL + "/images/mobileimages/Redmi Note8.jpeg"}alt=""  />
       </div>
       <div className="card-header">
<h6>Redmi Note 8 (Space Blue, 128 GB)</h6>
<p>6 GB RAM | 128 GB ROM|16.0 cm (6.3 inch) Full HD+ Display|48MP + 8MP | 13MP Front Camera</p>
<h4> ₹14,989</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton /> 
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>


        
    </div>
    </div>


    <div class ="card">
        <br/>
        <div className="catalog-section-title"><h1 className="Oppo">Samsung Mobiles</h1></div>
        <div class="row">


        <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body">
<img src={process.env.PUBLIC_URL + "/images/mobileimages/Samsung Galaxy A21s.jpeg"}alt=""  />
       </div>
       <div className="card-header">
<h6>Samsung Galaxy A21s (Black, 64 GB)</h6>
<p>4 GB RAM | 64 GB ROM | Expandable Upto 512 GB|16.51 cm (6.5 inch) HD+ Display|48MP | 13MP Front Camera</p>
<h4> ₹16,499</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton /> 
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>


        <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body">
<img src={process.env.PUBLIC_URL + "/images/mobileimages/Samsung Galaxy A50s.jpeg"}alt=""  />
       </div>
       <div className="card-header">
<h6>Samsung Galaxy A50s(White,128 GB)</h6>
<p>4 GB RAM | 128 GB ROM|16.26 cm (6.4 inch) Full HD+ Display|48MP + 8MP + 5MP | 32MP Front Camera</p>
<h4> ₹18,570</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton /> 
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>


        <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body">
<img src={process.env.PUBLIC_URL + "/images/mobileimages/Samsung Galaxy A51.jpeg"} alt="" />
       </div>
       <div className="card-header">
<h6>Samsung Galaxy A51 (Black, 128 GB)</h6>
<p>6 GB RAM | 128 GB ROM | Expandable 512 GB|16.26 cm (6.4 inch) Full HD+ Display|48MP| 32MP Front Camera</p>
<h4> ₹25,250</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton /> 
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>



        <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body">
<img src={process.env.PUBLIC_URL + "/images/mobileimages/Samsung Galaxy M11.jpeg"}alt=""  />
       </div>
       <div className="card-header">
<h6>Samsung Galaxy M11 (Blue, 32 GB)</h6>
<p>3 GB RAM | 32 GB ROM | Expandable Upto 512 GB|16.26 cm (6.4 inch) HD+ Display|13MP | 8MP Front Camera</p>
<h4> ₹10,999</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton /> 
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>


        <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body">
<img src={process.env.PUBLIC_URL + "/images/mobileimages/Samsung Galaxy M30s.jpeg"} alt="" />
       </div>
       <div className="card-header">
<h6>Samsung Galaxy M30s (Blue, 64 GB)</h6>
<p>4 GB RAM | 64 GB ROM | Expandable Upto 512 GB|16.26 cm (6.4 inch) Full HD Display|48MP| 16MP Front Camera</p>
<h4> ₹14,999</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton /> 
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>


        <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body">
<img src={process.env.PUBLIC_URL + "/images/mobileimages/Samsung Galaxy M31.jpeg"}alt=""  />
       </div>
       <div className="card-header">
<h6>Samsung Galaxy A31 (Black, 128 GB)</h6>
<p>6 GB RAM | 128 GB ROM | Expandable 512 GB|16.26 cm (6.4 inch) Full HD+ Display|48MP| 20MP Front Camera</p>
<h4> ₹21,999</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton /> 
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>


        <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body">
<img src={process.env.PUBLIC_URL + "/images/mobileimages/Samsung Galaxy S9plus.jpeg"}alt=""  />
       </div>
       <div className="card-header">
<h6>Samsung Galaxy S9Plus (Black,64 GB)</h6>
<p>6 GB RAM | 64 GB ROM | Expandable Upto 400 GB|15.75 cm (6.2 inch) Quad HD+ Display|12MP|8MP Front Camera</p>
<h4> ₹30,999</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton /> 
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>


        <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body">
<img src={process.env.PUBLIC_URL + "/images/mobileimages/Samsung Galaxy S10 lite.jpeg"} alt="" />
       </div>
       <div className="card-header">
<h6>Samsung Galaxy S10Lite(Blue, 128 GB)</h6>
<p>8 GB RAM | 128 GB ROM | Expandable Upto 1 TB|17.02 cm (6.7 inch) Full HD+ Display|48MP  | 32MP Front Camera</p>
<h4> ₹42,999</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton /> 
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>



        <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body">
<img src={process.env.PUBLIC_URL + "/images/mobileimages/Samsung Galaxy S20 plus.jpeg"}alt=""  />
       </div>
       <div className="card-header">
<h6>Samsung Galaxy S10 Plus (Black)</h6>
<p>8 GB RAM | 512 GB ROM | Expandable 512 GB|16.26 cm (6.4 inch) Quad HD+ Display|16MP | 10MP Front Camera</p>
<h4> ₹73,800</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton /> 
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>


        <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body">
<img src={process.env.PUBLIC_URL + "/images/mobileimages/Samsung Galaxy S20 Ultra.jpeg"}alt=""  />
       </div>
       <div className="card-header">
<h6>Samsung Galaxy S20 Ultra (Grey)</h6>
<p>8 GB RAM | 512 GB ROM | Expandable 512 GB|16.26 cm (6.4 inch) Quad HD+ Display|16MP | 30MP Front Camera</p>
<h4> ₹97,999</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton /> 
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>


       </div>
       </div>
          



    <div class ="card">
        <br/>
        <div className="catalog-section-title"><h1 className="Vivo">Vivo Mobiles</h1></div>
        <div class="row">


        <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body">
<img src={process.env.PUBLIC_URL + "/images/mobileimages/Vivo Y15.jpeg"}alt=""  />
       </div>
       <div className="card-header">
<h6>Vivo Y15 (Burgundy Red, 64 GB)</h6>
<p>4 GB RAM | 64 GB ROM | Expandable Upto 256 GB|16.13 cm (6.35 inch) HD+ Display|13MP  | 16MP Front Camera</p>
<h4> ₹12,990</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton /> 
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>


        <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body">
<img src={process.env.PUBLIC_URL + "/images/mobileimages/Vivo Y91i.jpeg"}alt=""  />
       </div>
       <div className="card-header">
<h6>Vivo Y91i (Fusion Black, 32 GB)</h6>
<p>2 GB RAM | 32 GB ROM | Expandable 256 GB|15.8 cm (6.22 inch) HD+ Display|13MP| 5MP Front Camera</p>
<h4> ₹9,540</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton /> 
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>


        <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body">
<img src={process.env.PUBLIC_URL + "/images/mobileimages/Vivo Z1 pro.jpeg"}alt=""  />
       </div>
       <div className="card-header">
<h6>Vivo Z1Pro (Sonic Black, 128 GB)</h6>
<p>6 GB RAM | 128 GB ROM | Expandable 256 GB|16.59 cm (6.53 inch) Full HD+ Display|16MP | 32MP Front Camera</p>
<h4> ₹16,990</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton /> 
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>


        <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body">
<img src={process.env.PUBLIC_URL + "/images/mobileimages/Vivo Z1 X.jpeg"}alt=""  />
       </div>
       <div className="card-header">
<h6>Vivo Z1x (Fusion Blue, 64 GB)</h6>
<p>6 GB RAM | 64 GB ROM|16.21 cm (6.38 inch) Full HD+ Display|48MP + 8MP + 2MP | 32MP Front Camera</p>
<h4> ₹15,990</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton /> 
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>



    </div>
    </div>



    <div class ="card">
        <br/>
        <div className="catalog-section-title"><h1 className="Nokia">Nokia Mobiles</h1></div>
        <div class="row">



        <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body">
<img src={process.env.PUBLIC_URL + "/images/mobileimages/Nokia 7.2.jpeg"}alt=""  />
       </div>
       <div className="card-header">
<h6>Nokia 7.2 (Charcoal, 64 GB)</h6>
<p>6 GB RAM | 64 GB ROM | Expandable 512 GB|16.0 cm (6.3 inch) Full HD+ Display|48MP | 20MP Front Camera</p>
<h4> ₹18,099</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton /> 
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>


        <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body">
<img src={process.env.PUBLIC_URL + "/images/mobileimages/Nokia 150.jpeg"}alt=""  />
       </div>
       <div className="card-header">
<h6>Nokia 150/150 DS  (Black)</h6>
<p>4 MB RAM | 4 MB ROM | Expandable Upto 32 GB|6.1 cm (2.4 inch) VGA Display|0.3MP Rear Camera</p>
<h4> ₹1,644</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton /> 
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>


        <div className="pricing-column col-lg-3 col-md-6">
        <div className="card-body">
<img src={process.env.PUBLIC_URL + "/images/mobileimages/Nokia105 ss.jpeg"} alt="" />
       </div>
       <div className="card-header">
<h6>Nokia 105 ss</h6>
<p>4 MB RAM | 4 MB ROM|4.57 cm (1.8 inch) Quarter QVGA Display|800 mAh Battery</p>
<h4> ₹1,000</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton /> 
<p><i class="fas fa-truck"></i> Free Shipping</p>
        </div>  
        </div>



        </div>
    </div>



</div>
}
export default Mobiles;